import React from 'react';
import { FaCircleUser } from 'react-icons/fa6';
import Navbar from '../components/body_nav';
import node from '../assets/images/skills/node.png';
import react from '../assets/images/skills/react.png';
import api from '../assets/images/skills/api.png';
import bootstrap from '../assets/images/skills/bootStrap.png';
import css from '../assets/images/skills/css.png';
import express from '../assets/images/skills/express.png';
import firebase from '../assets/images/skills/firebase.png';
import github from '../assets/images/skills/github.png';
import html from '../assets/images/skills/html.png';
import javaScritp from '../assets/images/skills/javaScripte.png';
import mono from '../assets/images/skills/mono.png';
import monogo from '../assets/images/skills/monogo.png';
import mui from '../assets/images/skills/mui.png';
import nestJs from '../assets/images/skills/nest.png';
import nextjs from '../assets/images/skills/nextjs.png';
import npm from '../assets/images/skills/npm.png';
import pnpm from '../assets/images/skills/pnpm.png';
import Sqllite from '../assets/images/skills/Sqllite.png';
import tailwind from '../assets/images/skills/tailwind.png';
import ts from '../assets/images/skills/typescripte.png';
import vite from '../assets/images/skills/vite.png';
function Experties() {
  const frontEnd = [
    { img: html, name: 'Html' },
    { img: css, name: 'CSS' },
    { img: javaScritp, name: 'JavaScritp' },
    { img: ts, name: 'TypeScript' },
    { img: react, name: 'React' },
    { img: vite, name: 'ViteJs' },
    { img: nextjs, name: 'NextJs' },
    { img: tailwind, name: 'Tailwind' },
    { img: mui, name: 'Material Ui' },
    { img: bootstrap, name: 'Bootstrap' },
    { img: api, name: 'RestApi' },
    { img: firebase, name: 'FireBase' },
    { img: github, name: 'GitHub' },
    { img: mono, name: 'MonoRepo' },
    { img: pnpm, name: 'Pnpm' },
    { img: npm, name: 'Npm' },
  ];

  const backEnd = [
    { img: node, name: 'NodeJS' },
    { img: express, name: 'ExpressJS' },
    { img: nestJs, name: 'NestJs' },
    { img: javaScritp, name: 'JavaScritp' },
    { img: ts, name: 'TypeScript' },
    { img: api, name: 'RestApi' },
    { img: monogo, name: 'MonogoDB' },
    { img: Sqllite, name: 'SQLlite' },
    { img: firebase, name: 'FireBase' },
    { img: github, name: 'GitHub' },
    { img: mono, name: 'MonoRepo' },
    { img: pnpm, name: 'Pnpm' },
    { img: npm, name: 'Npm' },
  ];

  const exptert = [
    {
      icon: react,
      name: 'Frontend Development',
      description:
        'I create intuitive and responsive user interfaces using React,Js, HTML, and CSS. I focus on delivering visually appealing and interactive web applications that enhance user engagement and satisfaction.',
    },
    {
      icon: node,
      name: 'Backend Development',
      description:
        'I design efficient and secure server-side solutions with Node, Express, and MonogoDB. I develop robust applications that handle complex business logic and ensure smooth performance, focusing on data integrity and security.',
    },
    {
      icon: node,
      name: 'Mobile App Development',
      description:
        'I design and develop mobile applications with a focus on performance and user experience. Leveraging modern frameworks such as React Native, I ensure seamless cross-platform functionality.',
    },
    {
      icon: node,
      name: 'Management Systems Design',
      description:
        'I specialize in designing comprehensive management systems tailored to streamline business operations. With expertise in creating user-friendly dashboards, database structures, and workflow automation, I ensure that businesses can efficiently manage resources, track performance, and optimize decision-making processes.',
    },
  ];
  return (
    <>
      <Navbar title={'Experties'} icon={<FaCircleUser />} id={'experties'} />

      <div className="overflow-y-auto">
        <div class="pt-3 w-[95%]">
          <p class="text-lightgrey">
            <span className="text-xl font-bold">A</span> strong foundation in
            both frontend and backend development, I bring a holistic approach
            to building robust and scalable web applications. As a frontend
            developer, I excel in creating intuitive and responsive user
            interfaces using React, Js, HTML, and CSS. On the backend, I design
            and implement efficient and secure server-side solutions with Node,
            Express, and MonogoDB.
          </p>
          <br></br>

          <p class="text-lightgrey">
            Beyond web development, I have extensive experience in database
            management, ensuring data integrity and optimal performance. I also
            specialize in automating workflows, and deploying applications to
            cloud environments. My expertise extends to integrating various
            technologies, working with APIs, and ensuring that each project I
            work on is not only functional but also optimized for performance
            and maintainability. Explore this section to understand the breadth
            of my skills and how I can contribute to your next project.
          </p>
        </div>

        <h4 class="py-4 text-2xl font-sans font-bold text-darkgrey">
          What I Do!
        </h4>
        <div class="flex flex-wrap">
          {exptert.map((item, index) => (
            <>
              <div class="flex lg:w-[48%] bg-primary p-3 m-[1%] rounded md:w-96">
                <div class="flex items-start pt-2 rounded-full w-[12rem] ">
                  <img src={item.icon} alt="skill-icon" class="w-full " />
                </div>
                <div class="h-50 ml-4 flex w-auto flex-col justify-center">
                  <h4 class="text-xl font-bold text-lightgrey dark:text-white">
                    {item.name}
                  </h4>
                  <p class="font-dm text-sm font-medium text-darkgrey">
                    {item.description}
                  </p>
                  <h5 class="font-bold mt-4 text-lightgrey dark:text-white">
                    Tools & Technologies :
                  </h5>
                  <div class="flex flex-wrap gap-3 mt-4">
                    {item?.name === 'Frontend Development'
                      ? frontEnd.map((skill, i) => (
                          <div
                            key={i}
                            class="h-[40px] w-[40px]   text-sm font-medium text-lightgrey dark:text-white"
                          >
                            <img src={skill.img} />
                          </div>
                        ))
                      : backEnd.map((skill, i) => (
                          <div
                            key={i}
                            class="h-[40px] w-[40px]   text-sm font-medium text-lightgrey dark:text-white"
                          >
                            <img src={skill.img} />
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>

        {/* <img src={web} alt="Me" class="absolute w-32 top-1 right-3" /> */}
      </div>
    </>
  );
}

export default Experties;
// import React from 'react';
// import { FaCircleUser } from 'react-icons/fa6';
// import Navbar from '../components/body_nav';
// import node from '../assets/images/skills/node.png';
// import react from '../assets/images/skills/react.png';
// import mongodb from '../assets/images/skills/monogo.png';
// import git from '../assets/images/skills/github.png';
// import docker from '../assets/images/skills/mono.png';

// function Experties() {
//   const expert = [
//     {
//       icon: react,
//       name: 'Frontend Developer',
//       description:
//         'I specialize in building intuitive, user-centric interfaces using React, JavaScript (ES6+), HTML, and CSS. My focus is on delivering responsive, engaging, and accessible web applications that provide exceptional user experiences.',
//     },
//     {
//       icon: node,
//       name: 'Backend Developer',
//       description:
//         'I architect secure and scalable server-side solutions using Node.js, Express, and MongoDB. I build efficient applications that handle complex logic, ensuring data integrity and smooth performance across systems.',
//     },
//   ];

//   const skills = [
//     'JavaScript (ES6+)',
//     'React.js',
//     'Node.js',
//     'Express.js',
//     'MongoDB',
//     'HTML5 & CSS3',
//     'RESTful APIs',
//     'Responsive Web Design',
//   ];

//   const tools = [
//     {
//       icon: mongodb,
//       name: 'MongoDB',
//     },
//     {
//       icon: git,
//       name: 'Git & GitHub',
//     },
//     {
//       icon: docker,
//       name: 'Docker',
//     },
//     // Add more tools as needed
//   ];

//   return (
//     <>
//       <Navbar title={'Experties'} icon={<FaCircleUser />} id={'experties'} />

//       <div className="overflow-y-auto">
//         <div className="pt-3 w-[95%]">
//           <p className="text-lightgrey">
//             <span className="text-xl font-bold">A</span> strong foundation in
//             both frontend and backend development allows me to bring a holistic
//             approach to building robust and scalable web applications. As a
//             frontend developer, I excel in crafting interactive user interfaces
//             with React, JS, HTML, and CSS. On the backend, I design and
//             implement efficient server-side solutions using Node.js, Express,
//             and MongoDB.
//           </p>
//           <br />

//           <p className="text-lightgrey">
//             Beyond web development, my expertise extends to database management,
//             ensuring data integrity and system performance. I also have
//             experience automating workflows and deploying applications to cloud
//             environments. Explore this section to understand my diverse skill
//             set and how I can contribute to your next project.
//           </p>
//         </div>

//         {/* Expertise Section */}
//         <h4 className="py-4 text-2xl font-sans font-bold text-darkgrey">
//           What I Do!
//         </h4>
//         <div className="flex flex-wrap">
//           {expert.map((item, index) => (
//             <div
//               key={index}
//               className="flex lg:w-[48%] bg-primary p-3 m-[1%] rounded md:w-96"
//             >
//               <div className="flex items-start pt-2 w-[12rem]">
//                 <img
//                   src={item.icon}
//                   alt={`${item.name} icon`}
//                   className="w-full"
//                 />
//               </div>
//               <div className="ml-4 flex flex-col justify-center">
//                 <h4 className="text-xl font-bold text-lightgrey dark:text-white">
//                   {item.name}
//                 </h4>
//                 <p className="text-sm font-medium text-darkgrey">
//                   {item.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Skills Section */}
//         <h4 className="py-4 text-2xl font-sans font-bold text-darkgrey">
//           My Skills
//         </h4>
//         <ul className="list-disc list-inside text-darkgrey">
//           {skills.map((skill, index) => (
//             <li key={index} className="py-1 text-sm font-medium">
//               {skill}
//             </li>
//           ))}
//         </ul>

//         {/* Tools Section */}
//         <h4 className="py-4 text-2xl font-sans font-bold text-darkgrey">
//           Tools I Use
//         </h4>
//         <div className="flex flex-wrap">
//           {tools.map((tool, index) => (
//             <div
//               key={index}
//               className="flex lg:w-[48%] bg-primary p-3 m-[1%] rounded md:w-96"
//             >
//               <div className="flex items-start pt-2 w-[12rem]">
//                 <img
//                   src={tool.icon}
//                   alt={`${tool.name} icon`}
//                   className="w-full"
//                 />
//               </div>
//               <div className="ml-4 flex flex-col justify-center">
//                 <h4 className="text-xl font-bold text-lightgrey dark:text-white">
//                   {tool.name}
//                 </h4>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

// export default Experties;
